import React from 'react';
import CurrencySelector from '../CurrencySelector';
import { SegmentedControl } from './ui';

/** Period switch and currency; sticks under the global header while scrolling. */
export default function DashboardControls({ t, period, onPeriodChange, currency, onCurrencyChange }) {
  const periods = [
    { value: 'today', full: t('periodToday', 'Today'), short: t('periodTodayShort', 'Today') },
    { value: 'yesterday', full: t('periodYesterday', 'Yesterday'), short: t('periodYesterdayShort', 'Yest.') },
    { value: '7d', full: t('period7Days', '7 days'), short: t('period7DaysShort', '7D') },
    { value: 'month', full: t('periodMonth', 'Month'), short: t('periodMonthShort', 'Month') }
  ].map((option) => ({
    value: option.value,
    label: (
      <>
        <span className="sm:hidden">{option.short}</span>
        <span className="hidden sm:inline">{option.full}</span>
      </>
    )
  }));

  return (
    <div className="sticky top-header z-30 -mx-4 -mt-6 mb-3 border-b border-gray-200/70 bg-gray-50/90 px-4 py-2 backdrop-blur-md dark:border-gray-800 dark:bg-gray-900/90 sm:-mx-8 sm:mb-4 sm:px-8">
      <div className="mx-auto flex max-w-6xl items-center gap-2">
        <SegmentedControl
          label={t('periodLabel', 'Period')}
          options={periods}
          value={period}
          onChange={onPeriodChange}
          className="min-w-0 flex-1 sm:flex-none"
          buttonClassName="px-2 py-2 text-xs sm:px-3.5 sm:py-1.5 sm:text-sm"
        />
        {currency && (
          <div className="ms-auto flex-shrink-0">
            <CurrencySelector value={currency} onChange={onCurrencyChange} compact />
          </div>
        )}
      </div>
    </div>
  );
}
